interface IApplicationProps {
    env: {
        ENVIRONMENT: string;
        CONFIGURATION_API_BASE_URL: string;
        CDN_BASE_URL: string;
        GATEWAY_SERVICE_TOKEN_VALIDATION_KEY: string;
        RECONFIRMATION_EXCLUDED_PROVIDERS: string;
    };
    recaptcha: {
        SIZE: "compact" | "normal" | "invisible" | undefined;
        SITE_KEY: string;
    };
}

const application: IApplicationProps = {
    env: {
        ENVIRONMENT: import.meta.env.MODE || 'local',
        CONFIGURATION_API_BASE_URL: import.meta.env.VITE_CONFIGURATION_API_BASE_URL || 'https://localhost:5001/v1',
        CDN_BASE_URL: import.meta.env.VITE_CDN_BASE_URL || "https://directidcdnstorage.blob.core.windows.net/content/resources/flags",
        GATEWAY_SERVICE_TOKEN_VALIDATION_KEY: import.meta.env.VITE_GATEWAY_SERVICE_TOKEN_VALIDATION_KEY || "ED666562B0EF8CA549DF3182CE9B0C02:401b09eab3c013d4ca54922bb802bec8fd5318192b0a75f201d8b3727429090fb337591abd3e44453b954555b7a0812e1081c39b740293f765eae731f5a65ed1",
        RECONFIRMATION_EXCLUDED_PROVIDERS: import.meta.env.VITE_RECONFIRMATION_EXCLUDED_PROVIDERS || ''
    },
    recaptcha: {
        SIZE: 'invisible',
        SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    }
};

export default application;
